import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { detectBrowserLanguage } from '../utils/languageDetection';

const LanguageRouter = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    const path = location.pathname;
    const pathSegments = path.split('/').filter(Boolean);
    
    // If no language prefix, redirect to browser's preferred language
    if (pathSegments.length === 0 || !['en', 'fr'].includes(pathSegments[0])) {
      const preferredLang = detectBrowserLanguage();
      const newPath = `/${preferredLang}${path === '/' ? '' : path}`;
      navigate(newPath, { replace: true });
      return;
    }

    // Extract language from URL
    const urlLang = pathSegments[0];
    const currentLang = i18n.language;
    
    // If language in URL differs from current language, change language
    if (urlLang !== currentLang) {
      i18n.changeLanguage(urlLang);
    }
  }, [location.pathname, i18n, navigate]);

  return children;
};

export default LanguageRouter;
